// แผนที่แปลงรหัสประเทศ (ชื่อย่อ) -> ชื่อเต็มภาษาไทย + รหัสธง (flagcdn iso2)
// รองรับ key หลายแบบ: รหัส FIFA 3 ตัว (BRA), ISO 2 ตัว (BR), ชื่ออังกฤษ (Brazil)
// ครอบคลุมชาติฟุตบอลโลกที่พบบ่อย ถ้าไม่เจอจะคืนค่าดิบกลับไป

const LIST = [
  { th: 'กาตาร์', en: 'Qatar', iso2: 'qa', fifa: 'QAT' },
  { th: 'เอกวาดอร์', en: 'Ecuador', iso2: 'ec', fifa: 'ECU' },
  { th: 'เซเนกัล', en: 'Senegal', iso2: 'sn', fifa: 'SEN' },
  { th: 'เนเธอร์แลนด์', en: 'Netherlands', iso2: 'nl', fifa: 'NED' },
  { th: 'อังกฤษ', en: 'England', iso2: 'gb-eng', fifa: 'ENG' },
  { th: 'อิหร่าน', en: 'Iran', iso2: 'ir', fifa: 'IRN' },
  { th: 'สหรัฐอเมริกา', en: 'USA', iso2: 'us', fifa: 'USA' },
  { th: 'เวลส์', en: 'Wales', iso2: 'gb-wls', fifa: 'WAL' },
  { th: 'อาร์เจนตินา', en: 'Argentina', iso2: 'ar', fifa: 'ARG' },
  { th: 'ซาอุดีอาระเบีย', en: 'Saudi Arabia', iso2: 'sa', fifa: 'KSA' },
  { th: 'เม็กซิโก', en: 'Mexico', iso2: 'mx', fifa: 'MEX' },
  { th: 'โปแลนด์', en: 'Poland', iso2: 'pl', fifa: 'POL' },
  { th: 'ฝรั่งเศส', en: 'France', iso2: 'fr', fifa: 'FRA' },
  { th: 'ออสเตรเลีย', en: 'Australia', iso2: 'au', fifa: 'AUS' },
  { th: 'เดนมาร์ก', en: 'Denmark', iso2: 'dk', fifa: 'DEN' },
  { th: 'ตูนิเซีย', en: 'Tunisia', iso2: 'tn', fifa: 'TUN' },
  { th: 'สเปน', en: 'Spain', iso2: 'es', fifa: 'ESP' },
  { th: 'คอสตาริกา', en: 'Costa Rica', iso2: 'cr', fifa: 'CRC' },
  { th: 'เยอรมนี', en: 'Germany', iso2: 'de', fifa: 'GER' },
  { th: 'ญี่ปุ่น', en: 'Japan', iso2: 'jp', fifa: 'JPN' },
  { th: 'เบลเยียม', en: 'Belgium', iso2: 'be', fifa: 'BEL' },
  { th: 'แคนาดา', en: 'Canada', iso2: 'ca', fifa: 'CAN' },
  { th: 'โมร็อกโก', en: 'Morocco', iso2: 'ma', fifa: 'MAR' },
  { th: 'โครเอเชีย', en: 'Croatia', iso2: 'hr', fifa: 'CRO' },
  { th: 'บราซิล', en: 'Brazil', iso2: 'br', fifa: 'BRA' },
  { th: 'เซอร์เบีย', en: 'Serbia', iso2: 'rs', fifa: 'SRB' },
  { th: 'สวิตเซอร์แลนด์', en: 'Switzerland', iso2: 'ch', fifa: 'SUI' },
  { th: 'แคเมอรูน', en: 'Cameroon', iso2: 'cm', fifa: 'CMR' },
  { th: 'โปรตุเกส', en: 'Portugal', iso2: 'pt', fifa: 'POR' },
  { th: 'กานา', en: 'Ghana', iso2: 'gh', fifa: 'GHA' },
  { th: 'อุรุกวัย', en: 'Uruguay', iso2: 'uy', fifa: 'URU' },
  { th: 'เกาหลีใต้', en: 'South Korea', iso2: 'kr', fifa: 'KOR' },
  { th: 'อิตาลี', en: 'Italy', iso2: 'it', fifa: 'ITA' },
  { th: 'นอร์เวย์', en: 'Norway', iso2: 'no', fifa: 'NOR' },
  { th: 'สวีเดน', en: 'Sweden', iso2: 'se', fifa: 'SWE' },
  { th: 'โคลอมเบีย', en: 'Colombia', iso2: 'co', fifa: 'COL' },
  { th: 'ชิลี', en: 'Chile', iso2: 'cl', fifa: 'CHI' },
  { th: 'ไนจีเรีย', en: 'Nigeria', iso2: 'ng', fifa: 'NGA' },
  { th: 'อียิปต์', en: 'Egypt', iso2: 'eg', fifa: 'EGY' },
  { th: 'แอลจีเรีย', en: 'Algeria', iso2: 'dz', fifa: 'ALG' },
  { th: 'สกอตแลนด์', en: 'Scotland', iso2: 'gb-sct', fifa: 'SCO' },
  { th: 'ตุรกี', en: 'Turkey', iso2: 'tr', fifa: 'TUR' },
  { th: 'ยูเครน', en: 'Ukraine', iso2: 'ua', fifa: 'UKR' },
  { th: 'เปรู', en: 'Peru', iso2: 'pe', fifa: 'PER' },
  { th: 'ปารากวัย', en: 'Paraguay', iso2: 'py', fifa: 'PAR' },
  { th: 'ออสเตรีย', en: 'Austria', iso2: 'at', fifa: 'AUT' },
  { th: 'ไทย', en: 'Thailand', iso2: 'th', fifa: 'THA' }
]

// สร้าง lookup จาก key ทุกแบบ (uppercase)
const MAP = {}
LIST.forEach(c => {
  const entry = { th: c.th, iso2: c.iso2 }
  ;[c.fifa, c.iso2, c.en].forEach(k => {
    if (k) MAP[k.toUpperCase()] = entry
  })
  MAP[c.th] = entry
})

function lookup (code) {
  if (!code) return null
  return MAP[String(code).trim().toUpperCase()] || MAP[String(code).trim()] || null
}

// คืนชื่อเต็มภาษาไทย (ถ้าไม่เจอคืนค่าดิบ)
export function countryName (code) {
  const c = lookup(code)
  return c ? c.th : (code || '-')
}

// คืน URL รูปธงขนาดเล็ก (ถ้าไม่เจอคืน '')
export function countryFlag (code) {
  const c = lookup(code)
  return c ? `https://flagcdn.com/24x18/${c.iso2}.png` : ''
}
